var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 592,
    height: 161,
    fill: "none",
    viewBox: "0 0 592 161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#113245",
    d: "M518.96 115.772c-1.098 0-1.996-.998-1.996-1.995V66.874c0-1.098.998-1.996 1.996-1.996h5.289c2.695 0 2.495 2.894 4.69 2.894 2.595 0 4.491-4.59 12.674-4.59 10.279 0 11.975 6.486 15.169 6.486 3.193 0 5.588-6.487 16.067-6.487 10.777 0 18.661 7.684 18.661 20.558v30.038a2.001 2.001 0 0 1-1.996 1.995h-7.385a2.001 2.001 0 0 1-1.995-1.995V85.236c0-6.587-4.192-10.778-10.08-10.778-5.987 0-10.079 4.291-10.079 10.778v28.541a2.001 2.001 0 0 1-1.996 1.995h-7.384c-1.098 0-1.996-.998-1.996-1.995V85.236c0-6.587-4.291-10.778-10.179-10.778s-10.079 4.291-10.079 10.778v28.541a2.001 2.001 0 0 1-1.996 1.995h-7.385ZM473.595 117.469c-11.077 0-19.26-7.584-19.26-20.857V66.874c0-1.098.998-1.996 1.996-1.996h7.385c1.097 0 1.995.998 1.995 1.996v27.842c0 7.385 4.591 11.476 10.978 11.476 6.486 0 10.977-4.191 10.977-11.476V66.874c0-1.098.998-1.996 1.996-1.996h7.385c1.097 0 1.996.998 1.996 1.996v46.903a2.002 2.002 0 0 1-1.996 1.995h-5.19c-2.694 0-2.494-2.694-4.79-2.694-2.694 0-4.091 4.391-13.472 4.391ZM427.551 115.772c-1.197 0-1.995-.998-1.995-1.996V66.874c0-1.098.898-1.996 1.995-1.996h7.385c1.297 0 1.996.998 1.996 1.996v46.902c0 1.098-.699 1.996-1.996 1.996h-7.385Zm-1.297-58.379c-.898 0-1.597-.798-1.597-1.597v-9.28c0-.799.799-1.597 1.597-1.597h10.279c.898 0 1.597.898 1.597 1.597v9.28c0 .898-.799 1.597-1.597 1.597h-10.279ZM362.502 133.735c-1.098 0-1.996-.998-1.996-1.996V66.874c0-1.098.998-1.996 1.996-1.996h5.189c2.695 0 2.296 3.193 4.99 3.193 3.094 0 5.189-4.89 14.969-4.89 6.986 0 12.774 2.495 16.766 6.886 4.39 4.69 6.985 11.975 6.985 20.258 0 8.383-2.595 15.568-6.985 20.258-4.092 4.491-9.78 6.886-16.766 6.886-9.081 0-11.376-3.892-13.871-3.892-1.297 0-1.896.699-1.896 2.096v16.066a2.002 2.002 0 0 1-1.996 1.996h-7.385Zm23.053-27.543c4.69 0 8.382-1.796 10.677-4.69 2.296-2.894 3.493-6.686 3.493-11.177 0-4.49-1.197-8.283-3.493-11.077-2.295-2.894-6.087-4.79-10.677-4.79-4.691 0-8.383 1.896-10.678 4.79-2.196 2.694-3.393 6.686-3.393 11.077 0 4.49 1.197 8.383 3.393 11.177 2.395 2.994 5.987 4.69 10.678 4.69ZM333.024 115.772c-1.198 0-1.996-.998-1.996-1.996V66.874c0-1.098.898-1.996 1.996-1.996h7.385c1.297 0 1.996.998 1.996 1.996v46.902c0 1.098-.699 1.996-1.996 1.996h-7.385Zm-1.297-58.379c-.898 0-1.597-.798-1.597-1.597v-9.28c0-.799.798-1.597 1.597-1.597h10.278c.899 0 1.597.898 1.597 1.597v9.28c0 .898-.798 1.597-1.597 1.597h-10.278ZM269.924 115.773c-1.098 0-1.996-.998-1.996-1.996v-67.86c0-1.098.898-1.996 1.996-1.996h7.385c1.098 0 1.996.998 1.996 1.996v18.861c0 1.397.698 1.996 1.696 1.996 2.695 0 3.593-3.593 12.874-3.593 11.376 0 19.859 7.784 19.859 21.755v28.841a2.003 2.003 0 0 1-1.996 1.996h-7.385c-1.098 0-1.996-.998-1.996-1.996V86.733c0-7.884-4.79-12.275-11.476-12.275-6.786 0-11.576 4.49-11.576 12.275v27.044a2.002 2.002 0 0 1-1.996 1.996h-7.385ZM225.28 117.469c-16.267 0-27.843-8.383-27.843-22.653v-.1c0-1.098.998-1.996 1.996-1.996h8.682c1.098 0 1.996.898 1.996 1.996v.1c0 7.484 5.888 11.376 15.169 11.376 8.881 0 14.669-3.692 14.669-10.179 0-4.89-2.994-7.584-9.979-8.981l-12.774-2.595c-11.476-2.295-17.763-8.781-17.763-19.36 0-13.172 11.875-20.856 26.346-20.856 15.068 0 25.846 8.083 25.846 20.657v.2c0 1.097-.998 1.995-1.996 1.995h-8.382c-1.098 0-1.996-.998-1.996-1.996v-.2c0-6.087-5.888-9.38-13.572-9.38-8.283 0-13.672 3.194-13.672 8.882 0 4.89 3.493 7.285 10.778 8.782l11.775 2.295c11.377 2.195 17.863 9.081 17.863 19.76 0 13.571-10.877 22.253-27.143 22.253Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 161,
    fill: "#128476",
    rx: 46.134
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M93.657 74.596a.821.821 0 0 1 .147-1.455L259.628 8.254a.82.82 0 0 1 .745.075l37.038 23.966a.821.821 0 0 1-.147 1.454L131.441 98.637a.822.822 0 0 1-.746-.075L93.657 74.596Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#128476",
    d: "M92.312 31.799V74.18l38.737 25.065V56.864L92.312 31.799Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#128476",
    d: "M59.96 66.134a.821.821 0 0 1 .664-.755l34.908-6.788a.822.822 0 0 1 .78.27L130.01 98.04a.822.822 0 0 1-.548 1.353l-71.008 6.52a.821.821 0 0 1-.895-.868l2.402-38.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M-141.932 163.96 25.776 98.335 64.513 123.4l-167.708 65.625-38.737-25.065Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M25.775 56.407 92.31 31.342l38.737 25.065-66.536 25.065-38.737-25.065Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M25.775 56.407V98.79l38.737 25.065V81.472L25.775 56.407Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 153,
    x2: 156.562,
    y1: 8,
    y2: 123.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#128476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -39,
    x2: -40.856,
    y1: 87,
    y2: 235.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#128476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 31.776,
    x2: -2.118,
    y1: 29.658,
    y2: 372.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#128476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 25.421,
    x2: 72.145,
    y1: 4.237,
    y2: 182.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#128476"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 161,
    fill: "#fff",
    rx: 46.134
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.f76c715ecb0f345788d4c3af3f5e595a.svg";
export { ForwardRef as ReactComponent };